/* Package JSON Import will be here */
import React, { Component } from "react";
import { connect } from "react-redux";
import queryString from 'query-string';
import { bindActionCreators } from "redux";
/* Package JSON Import will be here */

/* Project Import will be here */
import { navigateToDirectLink } from "reducers/common";
/* Project Import will be here */

const PublicRoutesAuthWrapper = (ChildComponent) => {
    class PublicRoutesAuthCheck extends Component {
        constructor(props) {
            super(props);

            /* Check for invalid selectedWholesaler reducer property */
            if (!window.enableQueryStringToken && this.props.localStore.selectedWholesaler === undefined) {
                localStorage.clear();
                window.location.reload();
            };

            /* Check for the login details already exist */
            if (!window.enableQueryStringToken && this.props.localStore.token && this.props.localStore.selectedWholesaler) {
                this.props.actions.navigateToDirectLink(queryString.parse(this.props.location.search));
                return false;
            }
        }

        render() {
            if (window.enableQueryStringToken || !this.props.localStore.token || !this.props.localStore.selectedWholesaler) {
                return <ChildComponent {...this.props} />;
            }
            else {
                return null;
            }
        }
    }

    const mapStateToProps = state => {
        return {
            localStore: state.localStore
        };
    };

    const mapDispatchToProps = dispatch => {
        return {
            actions: bindActionCreators({
                navigateToDirectLink
            }, dispatch)
        };
    };

    return connect(mapStateToProps, mapDispatchToProps)(PublicRoutesAuthCheck);
};

export default PublicRoutesAuthWrapper;